import { render, staticRenderFns } from "./InvoiceMemoList.vue?vue&type=template&id=2848c8d4&"
import script from "./InvoiceMemoList.vue?vue&type=script&lang=js&"
export * from "./InvoiceMemoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports